import VMasker from 'vanilla-masker';

const masks = ['(99) 9999-99999', '(99) 99999-9999'];
class PhoneInputMask {
  phoneInput;
  dddInput;

  constructor(element) {
    const input = element.querySelector('#form-field-maskphone');
    if (input) {
      this.phoneInput = element.querySelector('#form-field-phone');
      this.dddInput = element.querySelector('#form-field-ddd');
      VMasker(input).maskPattern(masks[0]);
      input.addEventListener('input', this.inputHandler.bind(this), false);
    }
  }

  inputHandler(event) {
    const max = 14;
    const input = event.target;
    if (!input) return;
    const digits = input.value.replace(/\D/g, '');
    const currentMask = input.value.length > max ? masks[1] : masks[0];
    VMasker(input).unMask();
    VMasker(input).maskPattern(currentMask);
    input.value = VMasker.toPattern(digits, currentMask);

    const onlyPhone = digits.slice(2, digits.length);
    const ddd = digits.slice(0, 2);

    if (digits.length > 11) return;
    if (this.phoneInput) this.phoneInput.value = onlyPhone;
    if (this.dddInput) this.dddInput.value = ddd;
  }
}

export default class PhoneInputMaskForms {
  constructor() {
    const forms = document.querySelectorAll('form');
    forms.forEach(form => new PhoneInputMask(form));
  }
}
